import { Component } from '@angular/core'

import { guarantorDisplayName, guarantorsOf, relationshipLabel, withoutGuarantors } from '@data/constants/contact-types'
import { LeaseDetailService } from '../../data/services/view/lease-detail.service'

@Component({
  selector: 'app-lease-customer',
  templateUrl: './lease-customer.component.html',
  styleUrls: ['./lease-customer.component.scss'],
})
export class LeaseCustomerComponent {
  constructor(private leaseDetailService: LeaseDetailService) {}

  get data() {
    return this.leaseDetailService.data as any
  }

  //* Plan v4.3 §9.5 · Los obligados solidarios se muestran aparte de los demás contactos: no tienen puesto ni
  //* participación, y sí tipo de persona y relación con el cliente.
  get otherContacts() {
    return withoutGuarantors<any>(this.data?.client?.contacts)
  }

  get guarantors() {
    return guarantorsOf(this.data?.client?.contacts)
  }

  readonly guarantorName = guarantorDisplayName
  readonly guarantorRelationship = relationshipLabel
}
